import { Fingerprint, FingerprintProvider } from '@fingerprint/react';

import { getConfig } from 'src/config';

export const FpProvider = ({ children }: React.PropsWithChildren) => {
  const { apiKey, url } = getConfig().DETECT;

  return (
    <FingerprintProvider
      apiKey={apiKey}
      // v3+ defaults to no caching; keep the v2 behaviour (sessionStorage, 1 hour) so the
      // consent flow's several getData calls share one identification.
      cache={{ storage: 'sessionStorage', duration: 3600 }}
      // Pin traffic to the custom subdomain: v4 would otherwise append Fingerprint's
      // default endpoints, which our CSP (connect-src) does not allow.
      endpoints={Fingerprint.withoutDefault([url])}
    >
      {children}
    </FingerprintProvider>
  );
};
